var _defs, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEndtoEndEncryption(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "fc3eaf04-6b58-4ed0-a3cd-39652208d977",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 60,
    viewBox: "0 0 100 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .fa7a6463-0ff0-4b93-8174-f045f3921ce8 {\r\n        fill: #fff;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "fa7a6463-0ff0-4b93-8174-f045f3921ce8",
    d: "M62.892,19.985H61.16V12.7a5.771,5.771,0,0,0-5.723-5.8H44.563a5.769,5.769,0,0,0-5.721,5.8v7.29H37.108a6.11,6.11,0,0,0-6.066,6.153V46.9a6.11,6.11,0,0,0,6.066,6.153H62.892A6.11,6.11,0,0,0,68.958,46.9V26.138A6.11,6.11,0,0,0,62.892,19.985ZM53.728,44.249H46.272L48.033,35.7a3.728,3.728,0,1,1,3.934,0Zm2.84-24.264H43.434V12.7a1.139,1.139,0,0,1,1.129-1.146H55.437A1.14,1.14,0,0,1,56.568,12.7Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndtoEndEncryption);
export default __webpack_public_path__ + "static/media/EndtoEndEncryption.f98d848f2a8325ed17a0343ff9979dac.svg";
export { ForwardRef as ReactComponent };